import { useState } from "react";
import axios from "axios";
import { motion } from "framer-motion";
import { toast } from "sonner";
import { Sparkles, Loader2, Check } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const ease = [0.16, 1, 0.3, 1];

export default function Shop() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!email.trim() || !email.includes("@")) {
      toast.error("Please enter a valid email.");
      return;
    }
    setLoading(true);
    try {
      await axios.post(`${API}/shop/waitlist`, { email });
      setDone(true);
      toast.success("You're on the list ✦ We'll whisper when the shop opens.");
      setEmail("");
    } catch (err) {
      toast.error("Something wavered. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <section id="shop" className="relative py-24 lg:py-36 overflow-hidden" data-testid="shop-section">
      <div className="absolute top-1/3 left-1/2 -translate-x-1/2 w-[520px] h-[520px] rounded-full bg-[#9C2A52]/10 blur-[130px] -z-0" />

      <div className="relative z-10 mx-auto max-w-[720px] px-6 lg:px-10 flex flex-col items-center text-center">
        <span className="inline-flex items-center gap-2 rounded-full border border-[#C9A24B]/40 px-4 py-1.5 text-[10px] tracking-[0.3em] uppercase text-[#C9A24B] mb-7" data-testid="shop-coming-soon-tag">
          <Sparkles className="w-3.5 h-3.5" strokeWidth={1.5} /> Coming Soon
        </span>

        <h2 className="font-display text-4xl sm:text-5xl tracking-tight text-[#EFE3CC]">
          The <span className="italic text-gold-gradient">Shop</span> is being conjured
        </h2>
        <p className="mt-5 text-sm sm:text-base text-[#B7A488] font-light max-w-md leading-relaxed">
          Handcrafted candles, crystals, and ritual tools are on their way. Leave your email and I'll let you know the moment the doors open.
        </p>

        {done ? (
          <div className="mt-10 flex flex-col items-center gap-3" data-testid="waitlist-success">
            <div className="w-14 h-14 rounded-full border border-[#C9A24B]/40 flex items-center justify-center glow-gold">
              <Check className="w-6 h-6 text-[#C9A24B]" strokeWidth={1.5} />
            </div>
            <p className="font-display italic text-2xl text-[#EFE3CC]">You're on the list.</p>
            <p className="text-sm text-[#B7A488] font-light">Watch your inbox — magic is brewing.</p>
          </div>
        ) : (
          <form onSubmit={submit} className="mt-10 w-full max-w-md flex flex-col sm:flex-row gap-3" data-testid="waitlist-form">
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              data-testid="waitlist-email"
              placeholder="your@email.com"
              className="flex-1 rounded-full bg-[#140B09] border border-[#C9A24B]/25 px-5 py-3.5 text-[#EFE3CC] placeholder:text-[#7a6a55] outline-none focus:border-[#C77E8A] focus:ring-1 focus:ring-[#C77E8A]/40 transition-all"
            />
            <button
              type="submit"
              disabled={loading}
              data-testid="waitlist-submit"
              className="rounded-full bg-gradient-to-r from-[#9C2A52] to-[#C77E8A] px-7 py-3.5 text-xs tracking-[0.2em] uppercase text-[#EFE3CC] shadow-[0_0_30px_rgba(156,42,82,0.3)] transition-transform duration-300 hover:scale-[1.03] disabled:opacity-60 flex items-center justify-center gap-2"
            >
              {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : null} Notify Me
            </button>
          </form>
        )}
      </div>
    </section>
  );
}
